import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const scleroderma: AnswerPathTreeNode = {
  path: 'scleroderma',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredSclerodermaDetails }],
};
